import Label from "components/atoms/forms/Label";
import { clsx } from "clsx";
import ErrorMessage from "components/atoms/forms/ErrorMessage";
import { UseFormSetError, UseFormSetValue } from "react-hook-form";

type Props = {
  choices: string[];
  setChoices: UseFormSetValue<any>;
  id: string;
  label: string;
  error: string | undefined;
  setError: UseFormSetError<any>;
  placeHolder?: string;
  additionClasses?: string;
  isDisabled?: boolean;
  inputAdditionalClasses?: string;
};

function ChoiceInputElement({
  choices,
  setChoices,
  id,
  label,
  error,
  setError,
  placeHolder,
  additionClasses,
  isDisabled,
  inputAdditionalClasses,
}: Props) {
  const handleOnKeyDown = (event: any) => {
    const choiceToBeAdded: string | undefined = event.target.value?.trim();
    // only press of these keys will trigger input
    if (["Enter", "Tab", ","].includes(event.key) && choiceToBeAdded) {
      if (!choices.includes(choiceToBeAdded)) {
        setChoices(id, [...choices, choiceToBeAdded], { shouldValidate: true });
      } else setError(id, { type: "custom", message: "Choice already exist in the list" });
      // clearing value from input and if the key pressed is "," - we prevent it from input
      // eslint-disable-next-line no-param-reassign
      event.target.value = "";
      event.preventDefault();
    }
  };

  const handleDeleteChoice = (choiceIdxToDelete: number) => {
    setChoices(
      id,
      choices.filter((choice: string, idx) => choiceIdxToDelete !== idx),
      { shouldValidate: true },
    );
  };

  return (
    <div className="w-full">
      <Label htmlFor={id} label={label} />
      <div
        className={clsx(
          "h-20 w-full overflow-y-scroll rounded-lg border 2xl:h-24",
          "border-white  bg-transparent p-1 scrollbar-hide",
          additionClasses,
        )}
      >
        {choices.map((choice: string, idx) => (
          <div
            className="m-1 inline-flex items-center rounded-ll border bg-transparent p-2 text-xxs font-medium 2xl:text-xs"
            key={choice}
          >
            <p className="break-all font-satoshi text-xs text-white">{choice}</p>
            <div>
              <button
                type="button"
                disabled={isDisabled}
                className="ml-2 flex h-5 w-5 items-center justify-center rounded-full bg-white font-bold"
                onClick={() => handleDeleteChoice(idx)}
              >
                {/* cross icon : X */}
                &times;
              </button>
            </div>
          </div>
        ))}
        <div className={clsx("inline-block", inputAdditionalClasses)}>
          <input
            className="w-full bg-transparent p-2 font-satoshi text-lg
             font-medium text-white placeholder:font-satoshi placeholder:text-lg 
            placeholder:font-medium placeholder:text-white placeholder:opacity-70 focus:outline-none"
            placeholder={placeHolder}
            onKeyDown={handleOnKeyDown}
            disabled={isDisabled}
          />
        </div>
      </div>
      {error && <ErrorMessage errorMessage={error} />}
    </div>
  );
}
export default ChoiceInputElement;
